// *工作流节点审批人类型
export enum EWorkflowStepUserType {
  /// <summary>
  /// 自定义用户
  /// </summary>
  CustomUser = 0,

  /// <summary>
  /// 项目创建人
  /// </summary>
  ProjectCreator = 10,

  /// <summary>
  /// 项目管理员
  /// </summary>
  ProjectManager = 20,

  /// <summary>
  /// 项目指令人
  /// </summary>
  ProjectAssigner = 30,

  /// <summary>
  /// 项目责任人
  /// </summary>
  ProjectPersonLiable = 40,

  /// <summary>
  /// 项目第二责任人
  /// </summary>
  ProjectSecondPersonLiable = 41,

  /// <summary>
  /// 流程提交人
  /// </summary>
  WorkflowSubmitUser = 50,

  /// <summary>
  /// 项目验收人
  /// </summary>
  ProjectAccepter = 60,

  /// <summary>
  /// 过程调度责任人
  /// </summary>
  SchedulePersonLiable = 100,

  /// <summary>
  /// 过程调度发起人
  /// </summary>
  ScheduleCreator = 101,

  // 前端添加值
  /// <summary>
  /// 流程责任人
  /// </summary>
  _WorkflowPersonLiable = 200,
}

